import { commonMessages } from '@carrier-ecat/ngecat-commonworkflowui';
const messages = { ...commonMessages, ...{
        "DC_FLEAVINGFLUIDFLOWTECHLOOP": {
            "id": "DC_FLEAVINGFLUIDFLOWTECHLOOP",
            "defaultMessage": "Leaving Fluid Flow"
        },
        "DC_NSTATICPRESSUREDROP": {
            "id": "DC_NSTATICPRESSUREDROP",
            "defaultMessage": "Static Pressure"
        },
        "DC_FENTERINGFLUIDFLOWFACILITYLOOP": {
            "id": "DC_FENTERINGFLUIDFLOWFACILITYLOOP",
            "defaultMessage": "Entering Fluid Flow"
        },
        "DC_FENTERINGFLUIDFLOWTECHLOOP": {
            "id": "DC_FENTERINGFLUIDFLOWTECHLOOP",
            "defaultMessage": "Entering Fluid Flow"
        },
        "BU_NBPHE": {
            "id": "BU_NBPHE",
            "defaultMessage": "BPHE"
        },
        "OPT_SINS06_PUMP": {
            "id": "OPT_SINS06_PUMP",
            "defaultMessage": "Pump"
        },
        "OPT_BINS12B_ALTERNATEHMIMOUNTINGLOCATION": {
            "id": "OPT_BINS12B_ALTERNATEHMIMOUNTINGLOCATION",
            "defaultMessage": "Alternate HMI Mounting Location"
        },
        "OPT_BINS14_SEISMICOPTIONKIT": {
            "id": "OPT_BINS14_SEISMICOPTIONKIT",
            "defaultMessage": "Seismic Option Kit"
        },
        "OPT_SINS02A_TCSFILLPUMP": {
            "id": "OPT_SINS02A_TCSFILLPUMP",
            "defaultMessage": "TCS Fill Pump"
        },
        "OPT_SINS02B_EXPANSIONTANKS": {
            "id": "OPT_SINS02B_EXPANSIONTANKS",
            "defaultMessage": "Expansion Tanks"
        },
        "OPT_BCON11B_ENERGYMANAGEMENT": {
            "id": "OPT_BCON11B_ENERGYMANAGEMENT",
            "defaultMessage": "Energy Management"
        },
        "OPT_BCON13A_STANDARHMIUPS": {
            "id": "OPT_BCON13A_STANDARHMIUPS",
            "defaultMessage": "Standard HMI UPS"
        },
        "OPT_BCON11A_EXTRASENSORREDUNDANCY": {
            "id": "OPT_BCON11A_EXTRASENSORREDUNDANCY",
            "defaultMessage": "Extra Sensor Redundancy"
        },
        "OPT_BCON13B_REMOTECONNECTIVITYGFCI": {
            "id": "OPT_BCON13B_REMOTECONNECTIVITYGFCI",
            "defaultMessage": "Remote Connectivity GFCI"
        },
        "OPT_BPLM01C_ALTERNATEFLOWMETER": {
            "id": "OPT_BPLM01C_ALTERNATEFLOWMETER",
            "defaultMessage": "Alternate Flowmeter"
        },
        "OPT_SPAC01_CHASSIS": {
            "id": "OPT_SPAC01_CHASSIS",
            "defaultMessage": "Chassis"
        },
        "OPT_BPAC15B_SHIPWITHCASTERS": {
            "id": "OPT_BPAC15B_SHIPWITHCASTERS",
            "defaultMessage": "Ship with Casters"
        },
        "OPT_BPAC15C_PADS": {
            "id": "OPT_BPAC15C_PADS",
            "defaultMessage": "Full Crate Shipping"
        },
        "OPT_BPAC15A_SKIDSNBAG": {
            "id": "OPT_BPAC15A_SKIDSNBAG",
            "defaultMessage": "Skids & Bags"
        },
        "OPT_BISL05_FWSPLUMBINGINSULTATION": {
            "id": "OPT_BISL05_FWSPLUMBINGINSULTATION",
            "defaultMessage": "FWS Plumbing Insulation"
        },
        "OPT_BISL05_FWSPLUMBINGINSULATION": {
            "id": "OPT_BISL05_FWSPLUMBINGINSULATION",
            "defaultMessage": "FWS Plumbing Insulation"
        },
        "OPT_SFIL04_TCSFILTER": {
            "id": "OPT_SFIL04_TCSFILTER",
            "defaultMessage": "TCS Filter"
        },
        "OPT_SPLM01A_FACILITYFWSCONNECTION": {
            "id": "OPT_SPLM01A_FACILITYFWSCONNECTION",
            "defaultMessage": "Facility (FWS) Connection"
        },
        "OPT_SPLM01B_TECHNOLOGYCONNECTION": {
            "id": "OPT_SPLM01B_TECHNOLOGYCONNECTION",
            "defaultMessage": "Technology Connection"
        },
        "REPORT_BPERFORMANCE": {
            "id": "REPORT_BPERFORMANCE",
            "defaultMessage": "Standard Performance"
        },
        "OPT_SFIL03_STRAINER": {
            "id": "OPT_SFIL03_STRAINER",
            "defaultMessage": "FWS Filter"
        },
        "DC_FFLUIDCONCFACILITYLOOP": {
            "id": "DC_FFLUIDCONCFACILITYLOOP",
            "defaultMessage": "Fluid Concentration"
        },
        "DC_FFLUIDCONCTECHNOLOGYLOOP": {
            "id": "DC_FFLUIDCONCTECHNOLOGYLOOP",
            "defaultMessage": "Fluid Concentration"
        },
        "OPT_SELT08_SCCR": {
            "id": "OPT_SELT08_SCCR",
            "defaultMessage": "Short Circuit Current Rating (SCCR)"
        },
        "OPT_SELT07_POWERDISCONNECT": {
            "id": "OPT_SELT07_POWERDISCONNECT",
            "defaultMessage": "Power/Disconnect"
        },
        "OPT_SELT06_VOLTAGE": {
            "id": "OPT_SELT06_VOLTAGE",
            "defaultMessage": "Voltage"
        },
        "OPT_BELT10_LOWHARMONICFILTER": {
            "id": "OPT_BELT10_LOWHARMONICFILTER",
            "defaultMessage": "Low Harmonic Filter"
        },
        "OPT_BELT09_AUTOMATICTRANSFERSWITCH": {
            "id": "OPT_BELT09_AUTOMATICTRANSFERSWITCH",
            "defaultMessage": "Automatic Transfer Switch"
        },
        "UI_RELEASE_NOTE_INITIAL_VERSION": {
            "id": "UI_RELEASE_NOTE_INITIAL_VERSION",
            "defaultMessage": "## New Features\n\n### 🌐 Multi-language Support\n\nWe're excited to announce the addition of comprehensive translation capabilities to our platform! This release introduces:\n- **20+ new languages** including Spanish, French, German, Japanese, and Chinese\n- **Automatic language detection** for seamless user experience\n- **Context-aware translations** that preserve technical terminology\n- **Custom dictionary support** for organization-specific terminology"
        },
        "UI_ElectricRequirement": {
            "id": "UI_ElectricRequirement",
            "defaultMessage": "Electric Requirement"
        },
        "BU_SFREQZ": {
            "id": "BU_SFREQZ",
            "defaultMessage": "Frequency"
        },
        "BU_SVOLTAGE": {
            "id": "BU_SVOLTAGE",
            "defaultMessage": "Voltage"
        },
        "BU_SMODEL": {
            "id": "BU_SMODEL",
            "defaultMessage": "Model"
        },
        "BU_SUNIT": {
            "id": "BU_SUNIT",
            "defaultMessage": "Unit"
        },
        "OPT_BINS12A_EXTERNALDOORLOCKS": {
            "id": "OPT_BINS12A_EXTERNALDOORLOCKS",
            "defaultMessage": "External Door Loocks for CDU"
        },
        "BU_SINTEGRATIONTYPE": {
            "id": "BU_SINTEGRATIONTYPE",
            "defaultMessage": "Integration Type"
        },
        "DESCRIBE_REQUIREMENTS": {
            "id": "DESCRIBE_REQUIREMENTS",
            "defaultMessage": "Describe Requirements"
        },
        "DETAILED_CONDITIONS": {
            "id": "DETAILED_CONDITIONS",
            "defaultMessage": "Detailed Conditions"
        },
        "ELECT_REQ": {
            "id": "ELECT_REQ",
            "defaultMessage": "Electric Requirement"
        },
        "EQUIP_REQ": {
            "id": "EQUIP_REQ",
            "defaultMessage": "Equipment"
        },
        "FACILITY_LOOP": {
            "id": "FACILITY_LOOP",
            "defaultMessage": "Facility Loop"
        },
        "TECH_LOOP": {
            "id": "TECH_LOOP",
            "defaultMessage": "Technology Loop"
        },
        "BU_SPRIMARYLOOPSTRAINER": {
            "id": "BU_SPRIMARYLOOPSTRAINER",
            "defaultMessage": "Primary Loop Strainer"
        },
        "BU_SSECONDLOOPFILTER": {
            "id": "BU_SSECONDLOOPFILTER",
            "defaultMessage": "Second Loop Filter"
        },
        "BU_SUNITSIZE": {
            "id": "BU_SUNITSIZE",
            "defaultMessage": "Unit Size"
        },
        "BU_SPRODUCT": {
            "id": "BU_SPRODUCT",
            "defaultMessage": "Product"
        },
        "DC_NTARGETCAPACITY": {
            "id": "DC_NTARGETCAPACITY",
            "defaultMessage": "Target Capacity"
        },
        "DC_NMINCAPACITYMARGIN": {
            "id": "DC_NMINCAPACITYMARGIN",
            "defaultMessage": "Minimum Capacity Margin"
        },
        "DC_FMINFLOWRATEPERCAPACITY": {
            "id": "DC_FMINFLOWRATEPERCAPACITY",
            "defaultMessage": "Minimum Flow Rate Per Capacity"
        },
        "DC_FENTERINGAIRTEMPTECHLOOP": {
            "id": "DC_FENTERINGAIRTEMPTECHLOOP",
            "defaultMessage": "Entering Temp."
        },
        "DC_FLEAVINGAIRTEMPFACILITYLOOP": {
            "id": "DC_FLEAVINGAIRTEMPFACILITYLOOP",
            "defaultMessage": "Leaving Temp."
        },
        "DC_SFLUIDTYPEFACILITYLOOP": {
            "id": "DC_SFLUIDTYPEFACILITYLOOP",
            "defaultMessage": "Fluid Type"
        },
        "DC_FLEAVINGFLUIDFLOWFACILITYLOOP": {
            "id": "DC_FLEAVINGFLUIDFLOWFACILITYLOOP",
            "defaultMessage": "Leaving Fluid Flow"
        },
        "DC_NALTITUDE": {
            "id": "DC_NALTITUDE",
            "defaultMessage": "Altitude"
        },
        "DC_NMAXPRESSUREDROP": {
            "id": "DC_NMAXPRESSUREDROP",
            "defaultMessage": "Max. Pressure Drop"
        },
        "DC_FENTERINGAIRTEMPFACILITYLOOP": {
            "id": "DC_FENTERINGAIRTEMPFACILITYLOOP",
            "defaultMessage": "Entering Temp."
        },
        "DC_FLEAVINGAIRTEMPTECHLOOP": {
            "id": "DC_FLEAVINGAIRTEMPTECHLOOP",
            "defaultMessage": "Leaving Temp."
        },
        "DC_SFLUIDTYPETECHLOOP": {
            "id": "DC_SFLUIDTYPETECHLOOP",
            "defaultMessage": "Fluid Type"
        }
    }
};
export { messages, };
